import './carousel.scss'

import _ from 'lodash'
import React from 'react'
import Slider from 'react-slick'

import { withTrans } from '@/i18n/withTrans'

import CardSectionMore from '../card-more/card-section-more'
import Title from '../title/title'
import { CarouselCard } from './carousel-card'

function Carousel({ title, data, t, i18n, category }) {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    className: 'carousel-container',
    arrows: false,
    dotsClass: 'slick-dots carousel-dots',
  }
  const range = _.range(data.length + 1)
  return (
    <div className="cards-carousel-container">
      <Title title={t(`trending.mobile.${title}`)} noLine />
      <Slider {...settings}>
        {_.map(range, (__, idx) => {
          switch (true) {
            case range.length - 1 === idx:
              return (
                <div className="carousel-box-card" key={'show_more'}>
                  <CardSectionMore
                    title={t(`trending.${title}`)}
                    category={category}
                    i18n={i18n}
                  />
                </div>
              )
            default:
              return (
                <div key={idx} className="carousel-box-card">
                  <CarouselCard item={data[idx].node} />
                </div>
              )
          }
        })}
      </Slider>
    </div>
  )
}

export default withTrans(Carousel)
